import {
  arrayBuilderItemSubsequentPageTitleUI,
  checkboxGroupUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import { makeSchemaForAllDisabilities } from '../../../../all-claims/utils/schemas';
import { validateBooleanGroup } from '../../../../all-claims/validations';
import { providerFacilityItemSchema } from '../../../schema';
import { treatedConditionsConfirmationField } from '../../../components/confirmationFields/TreatedConditionsConfirmation';

const { treatedDisabilityNames } = providerFacilityItemSchema.properties;

const REQUIRED_MESSAGE = 'Select at least one condition';

export default {
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(
      ({ formData }) =>
        `Conditions treated at ${formData?.providerFacilityName}`,
    ),
    treatedDisabilityNames: {
      ...checkboxGroupUI({
        title: 'Which conditions were treated at this facility?',
        required: true,
        labels: {},
        errorMessages: {
          required: REQUIRED_MESSAGE,
          atLeastOne: REQUIRED_MESSAGE,
        },
        // Options are the conditions being claimed (new conditions and rated
        // conditions selected for an increase).
        updateSchema: (
          _formData,
          _schema,
          _uiSchema,
          _index,
          _path,
          fullData,
        ) => makeSchemaForAllDisabilities(fullData || {}),
      }),
      // Replaces the platform validator: this one ignores keys for conditions
      // the Veteran has since removed, so stale selections can't satisfy the
      // "at least one" requirement.
      'ui:validations': [validateBooleanGroup],
      'ui:confirmationField': treatedConditionsConfirmationField,
    },
  },
  schema: {
    type: 'object',
    required: ['treatedDisabilityNames'],
    properties: {
      treatedDisabilityNames,
    },
  },
};
